import { render, staticRenderFns } from "./level.vue?vue&type=template&id=2c5919d5&scoped=true"
import script from "./level.vue?vue&type=script&lang=js"
export * from "./level.vue?vue&type=script&lang=js"
import style0 from "./level.vue?vue&type=style&index=0&id=2c5919d5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5919d5",
  null
  
)

export default component.exports